import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToBack } from 'srcReact/helpers/history'
import BackNavigationPure from './BackNavigationPure'

export default function BackNavigation({
  title,
  backText,
  showBackTextMobile = false, // show custom back text regardless of device. On normally we only show icon. But this property will override that behavior
  iconSize = 'large24',
  className,
  fitContent = true,
  theme = 'gray', //gray / lightblue / white
  titleClassName,
  iconClassName,
  customHandleBack
}) {
  const { t } = useTranslation()
  const {
    common: { isNative }
  } = useSelector((state) => state)

  const handleBack = () => {
    if (customHandleBack) {
      return customHandleBack()
    }
    redirectToBack(isNative)
  }

  return (
    <BackNavigationPure
      title={title}
      theme={theme}
      fitContent={fitContent}
      backText={backText}
      showBackTextMobile={showBackTextMobile}
      defaultBackText={t('profile.invites.back')}
      className={className}
      titleClassName={titleClassName}
      handleBack={handleBack}
      renderIcon={() => <Icon name='arrow-left24' size={iconSize} styleModifier={iconClassName} />}
    />
  )
}
